import * as React from 'react';
import { Box, Flex, Text } from '@chakra-ui/react';

interface ColorFieldProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
}

export const ColorField = ({
  label,
  value,
  onChange,
}: ColorFieldProps): React.ReactElement => {
  const inputId = React.useId();
  return (
    <Flex align='center' justify='space-between'>
      <Text
        id={inputId}
        fontSize='sm'
        color='var(--scoreboard-text-secondary, #b0b0b0)'
      >
        {label}
      </Text>
      <Flex align='center' gap={2}>
        <label htmlFor={`${inputId}-input`}>
          <Box
            w='32px'
            h='32px'
            borderRadius='md'
            border='1px solid rgba(255, 255, 255, 0.2)'
            bg={value}
            cursor='pointer'
            overflow='hidden'
            position='relative'
          >
            <input
              id={`${inputId}-input`}
              type='color'
              value={value}
              onChange={(e: React.ChangeEvent<HTMLInputElement>): void =>
                onChange(e.target.value)
              }
              aria-labelledby={inputId}
              style={{
                position: 'absolute',
                inset: 0,
                width: '100%',
                height: '100%',
                opacity: 0,
                cursor: 'pointer',
              }}
            />
          </Box>
        </label>
        <Text
          fontSize='xs'
          fontFamily='mono'
          color='var(--scoreboard-text-secondary, #b0b0b0)'
          aria-live='polite'
        >
          {value}
        </Text>
      </Flex>
    </Flex>
  );
};
